import useUser from '@/hooks/useUser';
import type { Portfolio } from '@/hooks/portfolio/usePortfolio';

type Args = {
  portfolioId: Portfolio['id'];
};

export function usePortfolioLinkSettings({ portfolioId }: Args) {
  const { data: user, queryStatus: status } = useUser();
  const data = user.portfolio?.links?.[portfolioId];

  return { data, status };
}
